import apiTrainers from '@/api/trainers'
import {
  filter,
  includes,
  isEmpty,
  isNil,
  map,
  pipe,
  prop,
  propOr,
  reject,
  unless,
  where,
} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getTrainersStart: '[trainers] Get trainers start',
  getTrainersSuccess: '[trainers] Get trainers success',
  getTrainersFailure: '[trainers] Get trainers failure',
}

export const actionTypes = {
  getTrainers: '[trainers] Get trainer',
}

export const getterTypes = {
  getTrainersBySchoolId: '[trainers] get trainers by schoolId',
}

const getters = {
  [getterTypes.getTrainersBySchoolId]: (state) => (schoolId) => {
    return filter(
      where({
        schools: pipe(map(prop('id')), includes(schoolId)),
      }),
      state.data
    )
  },
}

const mutations = {
  [mutationTypes.getTrainersStart](state) {
    state.isLoading = true
  },

  [mutationTypes.getTrainersSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getTrainersFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getTrainers](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getTrainersStart)

    return new Promise((resolve) => {
      apiTrainers
        .getTrainersList(params)
        .then((response) => {
          context.commit(mutationTypes.getTrainersSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data.list)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainersFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
